import React, { useState, useEffect } from 'react'
import PartnershipsLayout from 'components/PartnershipsSite/PartnershipsLayout'
import { usePageView } from 'hooks'
import { getStaticWrapper, THEME, mapMediaDocToVideojsObject } from 'utils'
import SponsorshipSecondary from 'components/PartnershipsSite/SponsorshipSecondary'
import ListSection from 'components/PartnershipsSite/ListSection'
import VideoPlayerLite from 'components/VideoPlayerLite'
import { MediaStore } from 'stores/media'

const ExperientialTop = ({ video }) => {
  const events = [
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/Superbowl.ef630bcb.png',
      title: 'Super Bowl'
    },
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/NFLDraft.fdbc112e.png',
      title: 'NFL Draft'
    },
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/NHL-winter-classic.1e054601.png',
      title: 'NHL Winter Classic'
    },
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/NHL-all-star-game.edbca1da.png',
      title: 'NHL All-Star'
    },
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/NHL-stadium-series.5e03c8f9.png',
      title: 'NHL Stadium Series'
    },
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/Golf-majors.67d8064f.png',
      title: 'Golf Majors'
    },
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/NBA-all-star.823ba75b.png',
      title: 'NBA All-Star'
    },
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/Final-Four.cd35b65b.png',
      title: 'NCAA Final Four'
    },
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/SpringTraining.c183af1d.png',
      title: 'MLB Spring Training'
    },
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/music-fest.867f32fb.png',
      title: 'Music Festivals'
    },
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/MLB-all-star.71d6ecd5.png',
      title: 'MLB All-Star'
    },
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/awards.f526df72.png',
      title: 'Awards Season'
    },
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/bachelor.3ab619ca.png',
      title: 'Bachelor Coverage'
    },
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/UFC-coverage.c90d9f23.png',
      title: 'UFC Coverage'
    },
    {
      img: 'https://chumley.barstoolsports.com/union/2021/06/08/tailgate.de1f4fcb.png',
      title: 'Tailgates'
    }
  ]

  return (
    <div className='experientialTop'>
      <div className='experientialTop__text'>
        <h1>25+ Barstool-owned experiential events per year</h1>
        <h1>
          Fans flock to our events to be part of Barstool, they meet our personalities and other fans of Barstool in
          once in a lifetime experiences.
        </h1>
      </div>
      {video && <VideoPlayerLite videoSource={video} />}
      <div className='experientialTop__content'>
        <h3>We steal the spotlight at every major tentpole</h3>
        <div className='experientialTop__grid'>
          {events.map(({ title, img }, idx) => (
            <div key={idx} className='event'>
              <img src={img} alt={title + '_img'} />
              <div>
                {title.split(' ').map((text, idx) => (
                  <h4 key={idx}>{text}</h4>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <style jsx>{`
        .experientialTop {
          background-color: #1d324e;
        }
        .experientialTop__text {
          width: 100%;
          padding: 4%;
          margin: 0 auto;
          background-color: #111828;
          text-align: center;
        }
        .experientialTop__text h1 {
          color: #fff;
          width: 100%;
          font-size: 1.75rem;
          line-height: 1.25;
        }
        .experientialTop__content {
          margin: 50px 0;
        }
        .experientialTop__content h3 {
          color: #fff;
          font-size: 1.6rem;
          margin: 0 auto 20px;
          width: 90%;
        }
        .experientialTop__img--desktop {
          display: block;
          width: 90%;
          margin: 0 auto;
        }
        .experientialTop__img--mobile {
          display: none;
        }
        .experientialTop__grid {
          width: 90%;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
          grid-gap: 8px;
          grip-column-gap: 8px;
        }
        .experientialTop__grid img {
          width: 100%;
          max-width: 183px;
          height: 100%;
          max-height: 175px;
          opacity: 0.4;
        }
        .event {
          width: 100%;
          max-height: 175px;
          position: relative;
          z-index: 1;
        }
        .event > div {
          opacity: 1;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          z-index: 2;
        }
        .event h4 {
          font-weight: 900;
          text-transform: uppercase;
          margin: 0;
          color: #fff;
          letter-spacing: 2.8px;
          font-size: 1.6rem;
          text-align: center;
          text-decoration: underline;
          text-decoration-color: #eb3e3f;
        }
        @media (max-width: ${THEME.BREAKPOINTS.MD}px) {
          .experientialTop__text h1 {
            font-size: 1.15rem;
          }
          .experientialTop__content h3 {
            font-size: 1.1rem;
          }
          .event h4 {
            font-size: 0.9rem;
            width: auto;
          }
        }
        @media (max-width: ${THEME.BREAKPOINTS.XS}px) {
          .experientialTop__content {
            margin: 30px 0;
          }
          .experientialTop__content h3 {
            text-align: center;
            font-size: 1.3rem;
          }
          .experientialTop__img--desktop {
            display: none;
          }
          .experientialTop__img--mobile {
            display: block;
            width: 90%;
            margin: 0 auto;
          }
          .experientialTop__img--mobile img {
            width: 100%;
          }
          .experientialTop__img--mobile h2 {
            text-transform: uppercase;
            margin: 0 8px;
            font-size: 2rem;
          }
          .experientialTop__grid {
            margin: 30px auto;
            grid-template-columns: 1fr 1fr 1fr;
          }
          .event h4 {
            font-size: 0.8rem;
            width: auto;
          }
        }
      `}</style>
    </div>
  )
}

const ExperientialBottom = () => {
  const images = [
    'https://chumley.barstoolsports.com/union/2021/06/09/CFB-Show.28e56f9f.jpeg?crop=0.74%2C0.99%2Cx0.13%2Cy0.00%2Csafe',
    'https://chumley.barstoolsports.com/union/2021/06/09/RnR3.9fa9d436.jpg?crop=0.55%2C0.99%2Cx0.22%2Cy0.01%2Csafe',
    'https://chumley.barstoolsports.com/union/2021/06/09/KFC-Radio-Live.e0ba6d53.jpg?crop=0.53%2C0.99%2Cx0.22%2Cy0.00%2Csafe',
    'https://chumley.barstoolsports.com/union/2021/06/09/RnR2.e2a1d16b.jpg?crop=0.46%2C0.99%2Cx0.27%2Cy0.00%2Csafe',
    'https://chumley.barstoolsports.com/union/2021/06/09/RnR1.be0efdb7.jpg?crop=0.84%2C0.99%2Cx0.07%2Cy0.00%2Csafe',
    'https://chumley.barstoolsports.com/union/2021/06/09/Pup-Punk.dfe3fc00.jpg?crop=0.57%2C0.99%2Cx0.22%2Cy0.00%2Csafe'
  ]

  return (
    <div className='experientialBottom'>
      <h3>Presenting Sponsorship</h3>
      <h3>On-Site Sponsor</h3>
      <ListSection
        subheader='Brands can align with scheduled Barstool events, or we can create a custom event for your brand.'
        list={[
          'Get product in the hands of consumers',
          'Create a memorable experience for fans to associate with your brand',
          'Additional reach benefits with media tied to the event'
        ]}
        styles={{
          background: 'transparent',
          paddingTop: '0',
          paddingBottom: '0'
        }}
      />
      <div className='imageGrid'>
        {images.map((src, idx) => (
          <img key={idx} src={src} alt={'image_' + idx} />
        ))}
      </div>
      <style jsx>{`
        .experientialBottom {
          width: 100%;
          padding: 50px;
        }
        .experientialBottom h3 {
          font-size: 1.6rem;
          margin: 0 auto 5px;
        }
        .imageGrid {
          width: 100%;
          margin: 50px auto 0;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          align-items: stretch;
        }
        .imageGrid img {
          object-position: center;
          object-fit: cover;
          width: 31%;
          margin: 5px;
        }
        @media (max-width: ${THEME.BREAKPOINTS.MD}px) {
          .experientialBottom h3 {
            font-size: 1.1rem;
            margin: 0 auto 2px;
          }
          .imageGrid {
            margin-top: 20px;
          }
        }
        @media (max-width: ${THEME.BREAKPOINTS.XS}px) {
          .experientialBottom {
            padding: 30px 20px;
          }
          .experientialBottom h3 {
            width: 100%;
            padding: 0 24px;
            font-size: 1.3rem;
          }
          .imageGrid {
            margin-top: 20px;
          }
          .imageGrid img {
            width: 45%;
          }
        }
      `}</style>
    </div>
  )
}

const SponsorshipExperiential = () => {
  usePageView()

  const [videoSource, setVideoSource] = useState({})

  useEffect(() => {
    const assignVideo = async () => {
      try {
        setVideoSource(mapMediaDocToVideojsObject(await MediaStore().findById('6cKw7vFdxhotmah4ZKZBRH')))
      } catch (e) {
        console.log(e)
      }
    }

    assignVideo()
  }, [])

  return (
    <PartnershipsLayout background='#D8D8D8'>
      <SponsorshipSecondary
        title={'EXPERIENTIAL'}
        details={'Bringing Barstool Sports to life for our fans'}
        top={<ExperientialTop video={videoSource} />}
        bottom={<ExperientialBottom />}
        centerSectionBreak
      />
    </PartnershipsLayout>
  )
}

export const getStaticProps = getStaticWrapper()

export default SponsorshipExperiential
